import { ListItem, Section } from '@/components';
import {
  UnderlyingYieldBearingAssetInterface,
  YieldBearingAssetInterface,
} from '@/interfaces';
import { formatNumberToAmountInUsdString } from '@/utils/formatUtils';
import { FC } from 'react';
import { TiChartArea } from 'react-icons/ti';
interface Props {
  asset?: YieldBearingAssetInterface | UnderlyingYieldBearingAssetInterface;
  label?: string;
  marketCap?: number;
  returnRate?: number | null;
}
const MarketCapitalizationIcon = TiChartArea as React.ComponentType<any>;
const MarketCapitalizationSection: FC<Props> = ({
  asset,
  label = 'Market Capitalization',
  marketCap,
}) => {
  const metricValue =
    marketCap !== undefined
      ? marketCap
      : asset
      ? 'mcap' in asset
        ? asset.mcap
        : asset.tvlUSD
      : null;
  return (
    <Section
      body={
        <ListItem
          leftIcon={<MarketCapitalizationIcon className="text-secondary" />}
          leftIconWidth={33}
          leftIconHeight={33}
          mainText={
            metricValue ? formatNumberToAmountInUsdString(metricValue) : null
          }
          mainTextColor={'primary'}
          subText={label}
          subTextSize={'caption'}
        />
      }
    />
  );
};
export default MarketCapitalizationSection;
